import { createSlice } from '@reduxjs/toolkit';
import { RefGroupTypeEnum } from '@trinity/management-app-client/enums';
import type { GroupState } from './interfaces';
import { sharedActions } from './shared-actions';

const initialState: GroupState = {
  id: 0,
  name: '',
  typeId: RefGroupTypeEnum.Org,
};

export const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {

  },
  extraReducers: builder => {
    builder.addCase(sharedActions.appStatedLoaded, (_, action) => {
      return action.payload.group;
    });
    builder.addCase(sharedActions.userLoggedOutAction, () => {
      return initialState;
    });
  },
});

export default groupSlice.reducer;